import React from "react"

const Footer = () => (
  <footer className="text-xl my-24 text-green-100">
    <a href="mailto:info@nilescity.com">info@nilescity.com</a>
  </footer>
)

export default Footer
